import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { ROUTE_NAME, API_URL } from '../constants'
import { BASE_URL } from '../../../constants'

import Create from '../../components/Create'
import TextInput from '../../../common/components/TextInput'
import Button from '../../../common/components/Button'

import useFetch from '../../../hooks/useFetch'

import { FIELDS } from './Form'

const FindUser = () => {
  const [query, setQuery] = useState('')
  const [selectedUser, setSelectedUser] = useState(null)
  const [{ response: users, isLoading, error }, { refresh }] = useFetch(
    `${BASE_URL}api/${API_URL}/find`,
    {
      method: 'POST',
      body: JSON.stringify({
        query,
      }),
    },
    [],
    query !== ''
  )
  const history = useHistory()

  if (selectedUser) return <CreateUser newUser={selectedUser} />

  return (
    <div>
      <h1>Search Sc.Gov for Users</h1>
      <TextInput
        placeholder="Username/First Name/Last Name"
        label="Search"
        value={query}
        onChange={setQuery}
        button={{ icon: 'fas fa-search', onClick: refresh }}
      />
      {isLoading ? (
        <div>Searching Database...</div>
      ) : users === null ? null : users.length === 0 ? (
        <div>No Users Found that match query.</div>
      ) : (
        <table>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Username</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, i) => (
              <tr key={i}>
                <td>{user.firstName}</td>
                <td>{user.lastName}</td>
                <td>{user.username}</td>
                <td>
                  {user.id ? (
                    <Button
                      text="Edit"
                      icon="fas fa-edit"
                      onClick={() => history.push(`/admin/users/${user.id}`)}
                    />
                  ) : (
                    <Button
                      text="Add"
                      icon="fas fa-plus"
                      onClick={() => setSelectedUser(user)}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

const CreateUser = ({ newUser }) => {
  FIELDS[0].defaultValue = newUser.username
  FIELDS[1].defaultValue = newUser.firstName
  FIELDS[2].defaultValue = newUser.lastName
  FIELDS[3].defaultValue = newUser.umbracoId
  return <Create apiUrl={API_URL} routeName={ROUTE_NAME} fields={FIELDS} />
}

export default FindUser
